import actions from './actions'
import getters from './getters'
import * as types from './mutation_types'

const state = {
  active: null,
  // поскольку весь код сайта подразумевает существование текущего нормального города,
  // случай левого города храним в отдельной переменной. обычный сити при этом всё равно
  // будет мск и спб
  otherCityMode: false,
  allCities: {},
}

const mutations = {
  [types.SET_ACTIVE] (state, city) {
    state.active = city
    document.documentElement.setAttribute('data-city', city.alias)
  },
  [types.SET_OTHER_CITY_MODE] (state, flag) {
    state.otherCityMode = flag
  },
  [types.SET_CITIES] (state, cities) {
    state.allCities = cities
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
